import React from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { VStack } from "@chakra-ui/react";
import { BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/breadcrumb";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { PageContent } from "../../components/PageContent/PageContent";
import { BusinessBreadcrumbs } from "../../components/Breadcrumbs/BusinessBreadcrumbs";
import { useAdminApiClient } from "../../hooks/useApiClient";
import { useToast } from "../../hooks/useToast";
import { GeoLocationDetailForm } from "../../forms/GeoLocationDetailForm";
import { CherryHubAdminApi } from "../../api/adminApiModels";

export const GeoLocationCreate: React.FC = () => {
  const { businessId } = useParams();
  const navigate = useNavigate();
  const apiClient = useAdminApiClient();
  const { showSuccessToast, showErrorToast } = useToast();

  const backToConfig = () =>
    navigate(`/admin/businesses/${businessId}/geo-fence-configuration`);

  const onSuccess = (geoLocation: CherryHubAdminApi.GeoLocation) => {
    showSuccessToast("Geo Location created.");
    if (geoLocation.Meta?.Id) {
      navigate(
        `/admin/businesses/${businessId}/geo-fence-configuration/geo-locations/${geoLocation.Meta.Id}`
      );
    } else {
      backToConfig();
    }
  };

  const onFailure = (message?: string) => {
    showErrorToast(message ?? "Failed to create Geo Location.");
  };

  return (
    <>
      <PageHeading>
        <PageHeading.Title>Create Geo Location</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <VStack alignItems="flex-start" width="100%" spacing={6}>
          <BusinessBreadcrumbs variant="pageHeading">
            <BreadcrumbItem>
              <BreadcrumbLink
                as={RouterLink}
                to={`/admin/businesses/${businessId}/geo-fence-configuration`}
              >
                Geo-Fence Configuration
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink
                as={RouterLink}
                to={`/admin/businesses/${businessId}/geo-fence-configuration/geo-locations/new`}
              >
                New Geo Location
              </BreadcrumbLink>
            </BreadcrumbItem>
          </BusinessBreadcrumbs>

          {businessId && (
            <GeoLocationDetailForm
              apiClient={apiClient}
              businessId={businessId}
              onCancel={backToConfig}
              onSuccess={onSuccess}
              onFailure={onFailure}
            />
          )}
        </VStack>
      </PageContent>
    </>
  );
};
